var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationChampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.84375H16.875",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7498 31.875C29.7279 31.875 26.6529 28.2975 27.2642 24.3319L29.0398 12.8381C29.1804 11.925 29.9698 11.25 30.8979 11.25H37.0142C37.9667 11.25 38.7692 11.9606 38.8798 12.9037L40.2654 24.5569C40.7286 28.4513 37.6798 31.875 33.7498 31.875Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01025 20.5537L9.14963 21.8906C11.5815 23.4112 14.6678 23.4112 17.0996 21.8906L19.239 20.5537",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1875 3.75H14.0625C15.0975 3.75 15.9375 4.59 15.9375 5.625V9.53438C15.9375 13.1119 16.9088 16.6219 18.75 19.6875C20.5912 22.755 21.5625 26.265 21.5625 29.8406V37.5C21.5625 39.5719 19.8844 41.25 17.8125 41.25H8.4375C6.36562 41.25 4.6875 39.5719 4.6875 37.5V29.8406C4.6875 26.2631 5.65875 22.7531 7.5 19.6875C9.34125 16.62 10.3125 13.11 10.3125 9.53438V5.625C10.3125 4.59 11.1525 3.75 12.1875 3.75Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9737 28.125C16.56 28.125 17.625 29.5219 17.625 30.8231C17.625 33.4631 13.2056 35.625 13.125 35.625C13.0444 35.625 8.625 33.4631 8.625 30.8231C8.625 29.5219 9.69 28.125 11.2762 28.125C12.1837 28.125 12.78 28.5488 13.125 28.9275C13.47 28.5488 14.0662 28.125 14.9737 28.125Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 31.875V41.25",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 41.25H37.5",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5813 18.75H28.125",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationChampaign);
export default __webpack_public_path__ + "static/media/navigation-champaign.e7714e4b.svg";
export { ForwardRef as ReactComponent };